import "../sass/app.scss";

import CarouselHeroCaption from "./modules/CarouselHeroCaption";
import StickyMenu from "./modules/StickyMenu";
import ThreeSlidesTextCarousel from "./modules/ThreeSlidesTextCarousel";
import Animations from "./modules/Animations";
import CarouselThreeImages from "./modules/CarouselThreeImages";
import CarouselImageFullWidth from "./modules/CarouselImageFullWidth";
import CarouselTestimonials from "./modules/CarouselTestimonials";
import CollapseMobileMenu from "./modules/CollapseMobileMenu";

// const threeSlideCarousel = new ThreeSlideCarousel();
const carouselHeroCaption = new CarouselHeroCaption();
const stickyMenu = new StickyMenu();
const threeSlidesTextCarosel = new ThreeSlidesTextCarousel();
const animations = new Animations();
const carouselThreeImages = new CarouselThreeImages();
const carouselImageFullWidth = new CarouselImageFullWidth();
const carouselTestimonials = new CarouselTestimonials();
const collapseMobileMenu = new CollapseMobileMenu();
